// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeIndicatorDescriptionPage_wrapper__z-Z5t"};